import React, { Component } from "react";
import "./style.css";
class Footer extends Component {
  render() {
    return (
      <div className="greet">
        <hr className="dropdown-divider" />
        <h7>&copy; Harshit Pandey 2023</h7>
        <hr className="dropdown-divider" />
      </div>
    );
  }
}

export default Footer;
